import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Campuses from "./pages/Campuses";
import Academics from "./pages/Academics";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Admissions from "./pages/Admissions";
import Contact from "./pages/Contact";
import LeadPopup from "./components/LeadPopup";
import AdminEvents from "./pages/AdminEvents";
import Events from "./pages/Events";
import useCampuses from "./hooks/useCampuses";
import { schoolInfo } from "./data/mock";

const WA_MESSAGE = "Hi! I'd like to know more about TIPS Bengaluru admissions.";

const WhatsAppButton = () => {
  const campuses = useCampuses();
  const mainCampus = campuses.find((c) => c.featured) || campuses[0];
  const rawPhone = (mainCampus?.whatsapp || mainCampus?.phone || schoolInfo.phone || "7619305034").replace(/\D/g, "");
  const waNumber = rawPhone.startsWith("91") ? rawPhone : `91${rawPhone}`;

  return (
    <a
      href={`https://wa.me/${waNumber}?text=${encodeURIComponent(WA_MESSAGE)}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      style={{ boxShadow: "0 4px 20px rgba(37,211,102,0.45)" }}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] rounded-full flex items-center justify-center transition-transform hover:scale-110 active:scale-95"
    >
      <svg viewBox="0 0 24 24" fill="white" className="w-7 h-7">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.117 1.528 5.849L.057 23.5a.5.5 0 0 0 .623.607l5.807-1.522A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.692-.5-5.24-1.378l-.374-.217-3.877 1.016 1.034-3.764-.235-.386A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
      </svg>
    </a>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/campuses" element={<Campuses />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/events" element={<Events />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <LeadPopup />
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
